import { awsAccessLogsInstaller } from "./access-logs";
import { awsFunctionCallerInstaller } from "./function-caller";
import { awsIamAssessmentInstaller } from "./iam-assessment";
import { awsIamWriteInstaller } from "./iam-write";
import { awsInventoryInstaller } from "./inventory";
import { rdsSecurityPerimeterInstaller } from "./security-perimeter";
import { AwsInstaller } from "./types";

export const awsInstaller: AwsInstaller = {
  base: { items: {} },
  "iam-assessment": awsIamAssessmentInstaller,
  "iam-write": awsIamWriteInstaller,
  inventory: awsInventoryInstaller,
  "function-caller": awsFunctionCallerInstaller,
  "rds-security-perimeter": rdsSecurityPerimeterInstaller,
  "access-logs": awsAccessLogsInstaller,
};
